import { ManuscriptWidget } from "./base.js";
import { typesetNodeIntoElement } from "components/organisms/manuscript/editor/visual/utils/typeset-content";

function splitAuthors(text) {
    return text
        .split(/\\and|\sand\s/gi)
        .map((value) => value.trim())
        .filter(Boolean);
}

export class MakeTitleWidget extends ManuscriptWidget {
    constructor(item) {
        super();
        this.preamble = {
            title: item.title
                ? {
                      node: item.title,
                      content: item.title.text,
                  }
                : undefined,
            authors: item.author
                ? [
                      {
                          node: item.author,
                          content: item.author.text,
                      },
                  ]
                : [],
            date: item.date,
        };
    }

    eq(other) {
        if (other.preamble.title?.content !== this.preamble.title?.content) {
            return false;
        }

        if (other.preamble.authors.length !== this.preamble.authors.length) {
            return false;
        }

        return this.preamble.authors.every(
            (author, index) => author.content === other.preamble.authors[index]?.content,
        );
    }

    toDOM(view) {
        const element = document.createElement("section");
        element.className = "ol-cm-maketitle";
        element.dataset.directEdit = "false";
        element.setAttribute("aria-hidden", "true");

        if (this.preamble.title?.content) {
            const title = document.createElement("div");
            title.className = "ol-cm-title";
            typesetNodeIntoElement(this.preamble.title.content, title, view.state);
            element.appendChild(
                this.bindSelection(title, view, {
                    from: this.preamble.title.node.editFrom,
                    to: this.preamble.title.node.editTo,
                }),
            );
        }

        if (this.preamble.authors.length) {
            const authorsElement = document.createElement("div");
            authorsElement.className = "ol-cm-authors";

            this.preamble.authors.forEach((author) => {
                const authors = splitAuthors(author.content);
                (authors.length ? authors : [author.content]).forEach((value) => {
                    const authorElement = document.createElement("div");
                    authorElement.className = "ol-cm-author";
                    typesetNodeIntoElement(value, authorElement, view.state);
                    authorsElement.appendChild(authorElement);
                });
            });

            element.appendChild(
                this.bindSelection(authorsElement, view, {
                    from: this.preamble.authors[0].node.editFrom,
                    to: this.preamble.authors[0].node.editTo,
                }),
            );
        }

        if (this.preamble.date?.text) {
            const date = document.createElement("div");
            date.className = "ol-cm-date";
            typesetNodeIntoElement(this.preamble.date.text, date, view.state);
            element.appendChild(
                this.bindSelection(date, view, {
                    from: this.preamble.date.editFrom,
                    to: this.preamble.date.editTo,
                }),
            );
        }

        return element;
    }
}
